import { useModal } from "@/context/modal/modal";
import UserBadge from "@/modules/user-badge";

import { LogoutIcon32 } from "@/components/icons";
import LogoutConfirmationModal from "@/components/ui/modal-with-context/modal-contents/logout-confirmation/logout-confirmation-modal-content";
import { LogOutTooltip } from "@/components/ui/tooltip/tooltip.styles";

import { Container, Wrapper, LogoutWrapper } from "./styles";

const TopBar = () => {
    const { openModal, setWidth, setMinHeight } = useModal();

    const confirmLogout = () => {
        setWidth("540px");
        setMinHeight("352px");
        openModal({
            content: (
                <LogoutConfirmationModal
                    title="logout:modal-contents:title"
                    description="logout:modal-contents:description"
                />
            ),
        });
    };

    return (
        <Wrapper>
            <Container>
                <LogOutTooltip
                    title="Log out"
                    placement="bottom"
                    slotProps={{
                        tooltip: {
                            sx: {
                                boxShadow: "0px 4px 4px 0 rgba(0,0,0,0.25)",
                            },
                        },
                        popper: {
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, -8], // -8 to decrease vertical offset value
                                    },
                                },
                            ],
                        },
                    }}
                >
                    <LogoutWrapper onClick={confirmLogout} data-test-id="log-out">
                        <LogoutIcon32 />
                    </LogoutWrapper>
                </LogOutTooltip>
                <UserBadge />
            </Container>
        </Wrapper>
    );
};

export default TopBar;
